import { BackdropCircularProgress } from "@websential/cosmic";
import { Grid } from "@mui/material";
import React from "react";

export interface ISetupFormLayout {
  isLoadingData: boolean;
  renderForm: boolean;
  isSubmittingForm: boolean;
  forMultipleColumn?: boolean;
  children: React.ReactNode;
}

export const SetupFormLayout: React.FC<ISetupFormLayout> = ({
  isLoadingData,
  renderForm,
  isSubmittingForm,
  forMultipleColumn,
  children,
}) => {
  return (
    <>
      {isLoadingData || !renderForm ? (
        <BackdropCircularProgress
          open={isLoadingData}
          testId="accountant-setup-loading"
        />
      ) : (
        <>
          <BackdropCircularProgress
            open={isSubmittingForm}
            testId="accountant-setup-submitting"
          />
          <Grid container size={{ xs: 12, sm: 12, md: 12, lg: 12, xl: 12 }}>
            {forMultipleColumn ? <Grid size={{ xs: 0, sm: 0, md: 0, lg: 0, xl: 0 }} /> : <Grid size={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} />}
            <Grid size={{ md: forMultipleColumn ? 12 : 10, lg: forMultipleColumn ? 12 : 10, xl: forMultipleColumn ? 12 : 10 }} sx={{ paddingTop: 1 }}>
              {children}
            </Grid>
            {forMultipleColumn ? <Grid size={{ xs: 0, sm: 0, md: 0, lg: 0, xl: 0 }} /> : <Grid size={{ xs: 1, sm: 1, md: 1, lg: 1, xl: 1 }} />}
          </Grid>
        </>
      )}
    </>
  );
};
